angular.module('app').factory('NotificationRepository',
    ['AprimaRestangular', function (AprimaRestangular) {
        'use strict';

        function getNotifications (uid) {
            var restangular = AprimaRestangular.get('patient');
            return restangular.one('notifications/patientportal/' + uid).get();
        }

        return{
            getNotifications: getNotifications
        };
    }]);